import React from "react";
import { useFetch } from "./useFetch";
import { LoadingSpinner } from "./Spinner";
import { DataErrorMsg } from "pages/analystDirectory/AnalystDirectory";

// safe only for static server html, unsafe for user contribution
export const HTMLComponent = ({ html, className = "" }) => (
  <div dangerouslySetInnerHTML={{ __html: html }} className={className} />
);

export const FetchHtmlComponent = ({ url }) => {
  const [html, isLoading, err] = useFetch(url, undefined, "GET", true, undefined, false);

  if (isLoading) return <LoadingSpinner />;
  if (err || !html) return <DataErrorMsg />;

  return <HTMLComponent html={html} />;
};
